import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useSession } from '../../features/session/SessionContext';
import { track } from './activity-client';

/**
 * Componente sin UI, montado una sola vez en `App.tsx`. Para sacar el
 * tracker del sitio: borrar esta carpeta, quitar su montaje en `App.tsx` y
 * las llamadas puntuales a `track(...)` que haya en otras pantallas.
 */
export function ActivityTracker() {
  const location = useLocation();
  const { state } = useSession();
  const identified = useRef(false);

  useEffect(() => {
    track('page_view');
  }, [location.pathname]);

  useEffect(() => {
    // Se dispara una sola vez por pestaña, la primera vez que la sesión
    // aparece autenticada: da igual si fue con Google o porque ya había una
    // sesión al cargar la página. Esa fila es el vínculo explícito entre el
    // `visitorId` anónimo y la cuenta real.
    if (state.status !== 'authenticated' || identified.current) return;
    identified.current = true;
    track('identify');
  }, [state.status]);

  return null;
}
